import React from 'react';
import ReactDOM from 'react-dom';
import RootRouter from 'router/router';
import { Provider } from 'react-redux';
import store from './stores';
import "@fontsource/roboto/100.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";
import './index.css';

ReactDOM.render(
  <Provider store={store}>
    <RootRouter />
  </Provider>,
  document.getElementById('root'));
